import React from 'react';

const DistributionAmount: React.FC = () => {
  return null;
};

export default DistributionAmount;
